import { types } from 'mobx-state-tree'
import { meterToCentimeter } from 'service/NumberFormatter'

import {
  CONTAINER_TYPE_22GP,
  CONTAINER_TYPE_42GP,
  CONTAINER_TYPE_45GP,
  FCLCargoContainerType,
  LCLCargoJSON,
} from '../Cargo'

const ContainerTypeEnum = types.enumeration([CONTAINER_TYPE_22GP, CONTAINER_TYPE_42GP, CONTAINER_TYPE_45GP])

export const FclCargoMst = types
  .model('FclCargo', {
    type: 'fcl',
    quantity: types.optional(types.number, 1),
    containerType: types.optional(ContainerTypeEnum, CONTAINER_TYPE_45GP),
    grossWeight: types.maybe(types.number),
    commodityType: '',
    commodityID: types.maybe(types.string),
  })
  .actions((self) => ({
    setContainerType(containerType: FCLCargoContainerType) {
      self.containerType = containerType
    },
    setQuantity(quantity: number | string) {
      self.quantity = Number(quantity)
    },
    setGrossWeight(grossWeight: number | string) {
      self.grossWeight = Number(grossWeight)
    },
    setCommodityType(commodityType: string, commodityID: string) {
      self.commodityType = commodityType
      self.commodityID = commodityID
    },
  }))
export type IFclCargoMst = typeof FclCargoMst.Type

export const LclCargoMst = types
  .model('LclCargo', {
    type: 'lcl',
    quantity: types.optional(types.number, 1),
    width: types.maybe(types.number),
    height: types.maybe(types.number),
    length: types.maybe(types.number),
    volume: types.maybe(types.number),
    grossWeight: types.maybe(types.number),
    commodityType: '',
    commodityID: types.maybe(types.string),
  })
  .preProcessSnapshot((snapshot: LCLCargoJSON) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    const override = {} as any
    if (snapshot && snapshot.width && snapshot.length && snapshot.height) {
      override.width = meterToCentimeter(snapshot.width)
      override.height = meterToCentimeter(snapshot.height)
      override.length = meterToCentimeter(snapshot.length)
    }
    return { ...snapshot, ...override }
  })
  .actions((self) => ({
    postProcessSnapshot(snapshot) {
      const override = { ...snapshot }
      if (snapshot.width && snapshot.length && snapshot.height) {
        override.width = override.width / 100
        override.height = override.height / 100
        override.length = override.length / 100
      } else {
        delete override.width
        delete override.height
        delete override.length
      }
      return override
    },
    setQuantity(quantity: number | string) {
      self.quantity = Number(quantity)
    },
    setVolume(volume: number | string) {
      self.volume = Number(volume)
    },
    setGrossWeight(grossWeight: number | string) {
      self.grossWeight = Number(grossWeight)
    },
    setCommodityType(commodityType: string, commodityID: string) {
      self.commodityType = commodityType
      self.commodityID = commodityID
    },
    updateSize(name: 'width' | 'height' | 'length', value: number | string) {
      self[name] = Number(value)
      const { length, width, height } = self

      // volume is in cubic meters
      const volume = ((length || 0) * (width || 0) * (height || 0)) / 1000000
      self.volume = volume
    },
  }))
export type ILclCargoMst = typeof LclCargoMst.Type
